import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import gameImage from '../assets/banner.png';

function Home() {

    const [userID, setUserID] = useState('')

    useEffect(() => {
        let params = new URLSearchParams(document.location.search);
        let value = params.get('logged_user_id');
        setUserID(value)
    }, []);


    return (
        <div className="home">
            <img src={gameImage} alt="Game" className="homeBanner" />
            <div className="homeContent">
                <div className="homeTitle">
                    Ваша психологическая разница в возрасте
                </div>
                Загрузи совместное фото и узнай психологическую разницу в возрасте в вашей паре!
                <Link to={"/game?logged_user_id="+userID} className="linkBtn">играть</Link>
            </div>
            <div className="homeFooter">
                <Link to="https://flami-dev.ru/rules.pdf" target={'_blank'}>Правила конкурса</Link>
                <Link to="https://flami-dev.ru/agreement.pdf" target={'_blank'}>Пользовательское соглашение</Link>
            </div>
        </div>
    );
}

export default Home;